import { Box, FormLabel } from '@mui/material';
import { PropsWithChildren } from 'react';

type LabeledFieldProps = PropsWithChildren<{
  label: string;
}>;

export function LabeledField({ label, children }: LabeledFieldProps) {
  return (
    <Box gap={1} display={'flex'} flexDirection={'column'}>
      <FormLabel>{label}</FormLabel>
      {children}
    </Box>
  );
}
